import { useState } from 'react';

import { PaymentStatusApplePay, CURRENCY_CODE, ApplePayButtonStatus } from 'constants/';
import { DeviceTypes } from 'constants/app';
import { useAmount, usePayment } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { useValidateMerchantMutation } from 'store/payment/service';
import { detectDeviceType } from 'utils';

import { useApplePayAvailability } from './hooks';
import { StatusMessage, getButtonClasses } from './status-message';
import { performPayment } from './utils';

const CartStatus = {
  READY: 0,
  PAYMENT_IN_PROGRESS: 1,
  PAYMENT_SUCCESS: 2,
  PAYMENT_FAILURE: 3,
  PAYMENT_CANCEL: 4,
};

const ApplePay = ({ acquiringID }: { acquiringID: number }) => {
  const [cardStatus, setCardStatus] = useState(CartStatus.READY);
  const { formKey, paymentData } = useAppSelector((state) => state.payment);
  const { currentAmount, currentAmountForPayment } = useAmount();

  const applePayButtonStatus = useApplePayAvailability();
  const [validateMerchant] = useValidateMerchantMutation();
  const { fetchSendPayment } = usePayment();

  const handleValidation = async (url: string) => {
    const validationResponse = await validateMerchant({ url }).unwrap();

    return validationResponse;
  };

  const onClick = async () => {
    setCardStatus(CartStatus.PAYMENT_IN_PROGRESS);

    try {
      const paymentStatus = await performPayment(
        paymentData?.ID || '',
        fetchSendPayment,
        acquiringID.toString(),
        currentAmount,
        currentAmountForPayment,
        handleValidation,
        CURRENCY_CODE,
      );

      switch (paymentStatus) {
        case PaymentStatusApplePay.CANCEL:
          setCardStatus(CartStatus.PAYMENT_CANCEL);
          break;
        case PaymentStatusApplePay.SUCCESS:
          setCardStatus(CartStatus.PAYMENT_SUCCESS);
          break;
        default:
          setCardStatus(CartStatus.PAYMENT_FAILURE);
      }
    } catch (err) {
      /* eslint-disable-next-line no-console */
      console.error('Payment error', JSON.stringify(err));
      setCardStatus(CartStatus.PAYMENT_FAILURE);
    }

    /* eslint-disable-next-line no-console */
    console.log('Card status:', cardStatus);
  };

  if (!applePayButtonStatus || applePayButtonStatus === ApplePayButtonStatus.UNKNOWN) {
    return <StatusMessage formKey={formKey} message="Проверяем Apple Pay..." />;
  }

  return detectDeviceType() === DeviceTypes.IOS ? (
    <div className={getButtonClasses(formKey)}>
      <button
        type="button"
        className="apple-pay-button-with-text apple-pay-button-black-with-text"
        id="apple-pay"
        onClick={onClick}
      />
    </div>
  ) : null;
};

export { ApplePay };
